import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AccessType } from './model/Reformulary';
import { createTheme, ThemeProvider } from '@mui/material';
import { red } from '@mui/material/colors';
import RegistrationSuccess from './views/claimant/registration.success/register.success';
import LandingPage from './views/landing.page/landing.page';
import LogIn from './views/login/login';
import Register from './views/claimant/register/register';
import ClaimantDashboard from './views/claimant/dashboard/dashboard';
import Exception from './views/claimant/exception/exception';
import AdminDashboard from './views/admin/dashboard/dashboard';
import AdminApprove from './views/admin/approve/approve';
import AssessorDashboard from './views/assessor/dashboard/dashboard';
import Header from './views/header/header';
import Footer from './views/footer/footer';
import TermsOfService from './views/terms.of.service/terms.of.services';
import PrivacyPolicy from './views/privacy.policy/privacy.policy';
import MessageComponent from './views/message/message';
import ForgotPassword from './views/forgot.password/forgot.password';
import ResetPassword from './views/reset.password/reset.password';
import BrowserWarning from './views/browser.warning/browser.warning';
import { CssBaseline } from "@mui/material";
// New imports from File B
import Preamble from './views/preamble/preamble';
import ClaimantSettings from './views/claimant/settings/settings';
import AdminSettings from './views/admin/settings/settings';
import AssessorSettings from './views/assessor/settings/settings';
import Faq from './views/faq/faq';
import ScrollToTop from './util/ScrollToTop';
import AdminException from './views/admin/exception/exception';
import DeleteUser from './views/admin/delete.user/delete.user';
import AssessorApprove from './views/assessor/approve/approve';
// Importing the CSS styles for the Material Design components
import '@material/button/mdc-button.scss';
import '@material/data-table/mdc-data-table.scss';
import '@material/form-field/mdc-form-field.scss';
import '@material/list/mdc-list.import.scss';
import '@material/menu/mdc-menu.import.scss';
import '@material/menu-surface/mdc-menu-surface.scss';
import '@material/radio/mdc-radio.scss';
import '@material/select/mdc-select.scss';
import '@material/tab-bar/mdc-tab-bar.scss';
import '@material/textfield/mdc-text-field.scss';
import './App.scss'
import { LanguageProvider } from './context/LanguageContext';

const theme = createTheme({
    palette: {
        primary: { main: '#ff4e00' },
        error: red,
    },
});

export default function App() {
    const [error, updateError] = useState();

    return (
        <Router>
            <ThemeProvider theme={theme}>
                <LanguageProvider>
                    <div className="app-container">
                        <CssBaseline />
                        <ScrollToTop />
                        <Header />
                        <BrowserWarning />
                        <MessageComponent message={error} handleError={updateError} />
                        <Routes>
                            {/*<Route path="/" element={<LandingPage handleError={updateError} />} />*/}
                            <Route path="/" element={<Preamble handleError={updateError} />} />
                            <Route path="/landing" element={<LandingPage handleError={updateError} />}/>
                            <Route path="/preamble" element={<Preamble handleError={updateError} />} />
                            <Route path="/login" element={<LogIn handleError={updateError} />} />
                            <Route path="/register" element={<Register handleError={updateError} />} />
                            <Route path="/registrationSuccess" element={<RegistrationSuccess handleError={updateError} />} />
                            <Route path="/forgotPassword" element={<ForgotPassword handleError={updateError} />} />
                            <Route path="/resetPassword/:token" element={<ResetPassword handleError={updateError} />} />
                            <Route path="/termsofservice" element={<TermsOfService />} />
                            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                            <Route path="/faq" element={<Faq />} />

                            {/* Private Routes - Claimant */}
                            <Route
                                path="/dashboard"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.MEMBER_CLAIMANT_ACCESS], AccessType[AccessType.NON_MEMBER_CLAIMANT_ACCESS]]}>
                                        <ClaimantDashboard handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/settings"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.MEMBER_CLAIMANT_ACCESS], AccessType[AccessType.NON_MEMBER_CLAIMANT_ACCESS]]}>
                                        <ClaimantSettings handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/exception"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.MEMBER_CLAIMANT_ACCESS], AccessType[AccessType.NON_MEMBER_CLAIMANT_ACCESS]]}>
                                        <Exception handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />

                            {/* Admin Routes */}
                            <Route
                                path="/admin/dashboard"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.ADMIN_ACCESS]]}>
                                        <AdminDashboard handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/admin/approve"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.ADMIN_ACCESS]]}>
                                        <AdminApprove handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/admin/settings"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.ADMIN_ACCESS]]}>
                                        <AdminSettings handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/admin/exception"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.ADMIN_ACCESS]]}>
                                        <AdminException handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/admin/deleteuser"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.ADMIN_ACCESS]]}>
                                        <DeleteUser handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />

                            {/* Assessor Routes */}
                            <Route
                                path="/assessor/dashboard"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.ASSESSOR_ACCESS]]}>
                                        <AssessorDashboard handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/assessor/approve"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.ASSESSOR_ACCESS]]}>
                                        <AssessorApprove handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/assessor/settings"
                                element={
                                    <PrivateRoute role={[AccessType[AccessType.ASSESSOR_ACCESS]]}>
                                        <AssessorSettings handleError={updateError} />
                                    </PrivateRoute>
                                }
                            />

                            {/* Fallback Route */}
                            <Route path="*" element={<div>404: Page not found</div>} />
                        </Routes>
                        <Footer />
                    </div>
                </LanguageProvider>
            </ThemeProvider>
        </Router>
    );
}

// PrivateRoute component: renders children if the user is valid, otherwise redirects to /login.
function PrivateRoute({ role, children }: { role: string[]; children: JSX.Element }) {
    const userData = sessionStorage.getItem('userId');
    let userRole = 'none';
    if (userData) {
        try {
            const parsedUser = JSON.parse(userData);
            userRole = parsedUser?.role || 'none';
        } catch (err) {
            userRole = 'none';
        }
    }

    return role.includes(userRole) ? children : <Navigate to="/login" replace />;
}